import React, { useState } from 'react'
import { Button, Form, Select, Spin } from 'antd';
import useForm from '../hooks/useForm';
import FormIteamInformation from './FormIteamInformation';
import { getListAdd, getOptionsSelect, itemsStepsAddList } from '../util/FormHelper';
import StepForm from './StepForm';
import FormIteamSpace from './FormIteamSpace';
import FormIteamLists from './FormIteamLists';
import TapOptions from './TapOptions';
import { putUpdateSection } from '../../../../config';


// Constantes para mayor claridad
const MAIN_STEPS = {
    INFORMATION: 0,
    ADD_LISTS: 1
}

const ADD_LISTS_STEPS = {
    SELECT_SPACES: 0,
    SELECT_LISTS: 1
}

const FormSectionEdit = ({ data, onClose }) => {
    const {
        form,
        infoClickup,
        color,
        loading,
        changeColor,
        setLoading,
        getListsByClickupSpace,
        getSpacesClickupForSection
    } = useForm({ data })

    const [{ mainStep, addListsStep }, setSteps] = useState({
        mainStep: 0,
        addListsStep: 0
    })

    const getIsSave = () => {
        if (mainStep === MAIN_STEPS.INFORMATION) return true
        if (mainStep === MAIN_STEPS.ADD_LISTS && addListsStep === ADD_LISTS_STEPS.SELECT_LISTS) return true
        return false
    }

    const getButtonText = () => {
        if (mainStep === MAIN_STEPS.INFORMATION) return 'Guardar'
        if (mainStep === MAIN_STEPS.ADD_LISTS && addListsStep === ADD_LISTS_STEPS.SELECT_SPACES) return 'Siguiente'
        if (mainStep === MAIN_STEPS.ADD_LISTS && addListsStep === ADD_LISTS_STEPS.SELECT_LISTS) return 'Guardar'
    }


    const handleNextStep = () => {
        const saveAddList = getIsSave()
        if (mainStep === 0 || saveAddList) return handleSave(mainStep + 1)

        getListsByClickupSpace(() => {
            setSteps(prev => ({
                ...prev,
                addListsStep: ADD_LISTS_STEPS.SELECT_LISTS
            }))
        })
    }

    const handleBackStep = () => {
        const saveAddList = getIsSave()
        const steps = {
            mainStep: saveAddList ? mainStep : MAIN_STEPS.INFORMATION,
            addListsStep: ADD_LISTS_STEPS.SELECT_SPACES
        }
        setSteps(steps)
    }

    const handleMoveStepAddList = () => {
        getSpacesClickupForSection(() => {
            setSteps({
                mainStep: 1,
                addListsStep: 0
            })
        })
    }

    const handleSave = () => {
        setLoading(true);
        const isSaveInformation = mainStep === MAIN_STEPS.INFORMATION
        const formList = form.getFieldValue(undefined);
        const listsClickup = getListAdd(formList.lists, infoClickup.lists)
        const formFinish = {
            name: formList.name,
            year: parseInt(formList.year.format('YYYY')),
            installed_capacity: formList.installed_capacity,
            color,
            type: formList.type,
            removeList: [],
            addList: []
        }
        if (isSaveInformation) {
            formFinish.removeList = formList.listsRemove.map((item) => ({clickupId: item}))
        } else {
            formFinish.addList = listsClickup
        }        
        putUpdateSection(data.sectionId, formFinish)
            .then(() => {
                onClose()
            })
            .catch((error) => {
                console.log(error);
            })
            .finally(() => {
                setLoading(false);
            })
    }

    return (
        <div className='relative w-full h-[600px] flex flex-col gap-2'>
            {loading && (
                <div className='absolute top-0 left-0 w-full h-full bg-white z-20 flex justify-center items-center'>
                    <Spin size="large" />
                </div>
            )}
            <Form form={form} className="w-full h-full overflow-y-auto" layout="vertical">
                <StepForm className={'w-full'} currentStep={mainStep}>
                    {/* Información */}
                    <StepForm.Step>
                        <p className='text-[16px] font-bold mb-4 border-b-2 border-[#E2E8F0] pb-2'>Información</p>
                        <FormIteamInformation
                            color={color}
                            changeColor={changeColor}
                        />

                        <p className='text-[16px] font-bold mb-4 border-b-2 border-[#E2E8F0] pb-2'>Remover Listas</p>
                        <Form.Item
                            name="listsRemove"
                            label="Listas"
                        >
                            <Select
                                showSearch
                                filterOption={(input, option) =>
                                    (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                }
                                mode="multiple"
                                placeholder="Selecciona los listas"
                                style={{ width: '100%' }}
                                options={getOptionsSelect(infoClickup.listsRemove)}
                            />
                        </Form.Item>
                    </StepForm.Step>
                    {/* Agregar mas Listas */}
                    <StepForm.Step>
                        <div>
                            <TapOptions tabs={itemsStepsAddList} selectIteam={addListsStep}></TapOptions>
                        </div>
                        <StepForm className={'mt-6'} currentStep={addListsStep}>
                            {/* Seleciona Espacios */}
                            <StepForm.Step>
                                <div className='w-full h-ful'>
                                    <FormIteamSpace
                                        spaces={infoClickup.spaces}
                                    />
                                </div>
                            </StepForm.Step>

                            {/* Seleciona Listas */}
                            <StepForm.Step className={"w-full h-full overflow-y-auto"}>
                                <div className='w-full h-full'>
                                    <FormIteamLists
                                        lists={infoClickup.lists}
                                    />
                                </div>
                            </StepForm.Step>
                        </StepForm>
                    </StepForm.Step>

                </StepForm>
            </Form>

            <div className='w-full flex gap-2 justify-end'>
                {mainStep === 1 && (
                    <Button
                        onClick={() => handleBackStep()}
                    >
                        Atrás
                    </Button>
                )}
                {mainStep === 0 && (
                    <Button
                        type="primary"
                        onClick={() => handleMoveStepAddList()}
                    >
                        Agregar listas
                    </Button>
                )}
                <Button
                    onClick={() => handleNextStep()}
                    type="primary"
                >
                    {getButtonText()}
                </Button>
            </div>
        </div>
    )
}

export default FormSectionEdit